<!--  -->
<template>
    <div class="message">
        <div class="message_name">
            <div class="name"><img :src="icon" class="icon" alt="">{{messageName}}</div>
            <div class="more" @click="goMessageList">更多></div>
        </div>
        <div class="list" v-if="!loading">
            <div class="item" v-for="(item, index) in list" :key="index">
                <div class="item_message" @click="goDetails(item)">{{item.subject}}</div>
                <div class="time">
                    <img :src="require('@/common/images/special/hot.gif')" v-if="index < 3" alt="">
                    <span v-else>{{item.releasetime}}</span>
                </div>
            </div>
        </div>
        <skeleton type='listcom' v-else active :options="{row: 10, lineHight: 18}" />
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    data() {
        return {

        }
    },
    props: ['messageName', 'list', 'isExam', 'loading', 'activeList', 'icon'],
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        goDetails(item) {
            if (item.urltype === 2) {
                window.open(item.linkurl)
            } else {
                window.open(`${location.origin}/messageDetails?contentid=${item.contentid}&token=${this.user.loginToken}`)
            }
        },
        goMessageList() {
            window.open(`${location.origin}/messageList?active=${this.activeList}&token=${this.user.loginToken}`)
        }
    },
    computed: {
        ...mapGetters(['user'])
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .message {
        // padding-top: 8px;
        // width: 100%;
        width: 490px;
        height: 360px;
        .message_name {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #E5E5E5;
            margin-bottom: 14px;
            .name {
                // width: 72px;
                font-size: 18px;
                line-height: 25px;
                font-weight: bold;
                padding-bottom: 10px;
                display: flex;
                align-items: center;
                // border-bottom: 2px solid #409EFF;
                .icon {
                    width: 16px;
                    height: 16px;
                    margin-right: 5px;
                }
            }
            .more {
                font-size: 14px;
                color: #999999;
                cursor: pointer;
                &:hover {
                    color: #409EFF;
                }
            }
        }
        .list {
            .item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 10px;
                &:last-of-type {
                    margin-bottom: 15px;
                }
                .item_message {
                    width: 400px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    line-height: 20px;
                    font-size: 14px;
                    color: #333333;
                    cursor: pointer;
                    &:hover {
                        color: #409EFF;
                    }
                }
                .time {
                    width: 40px;
                    text-align: center;
                    font-size: 14px;
                    color: #999999;
                    img {
                        width: 27px;
                        height: 19px;
                        margin: auto;
                    }
                }
            }
        }
        .contianer_S8Y9lJLI {
            height: 90%;
            &>div {
                // height: 80% !important;
            }
            .listCom_2QHM1mDh {
                padding: 0;
                .progActive_3tSycGMF {
                    height: 18px;
                }
            }
        }
    }
</style>